module.exports = "/packs/images/homepage/facilities/help-centre~0ad12eb03c9235b42095614999ff669c.jpg";